import jwtDecode from 'jwt-decode';
import secureLocalStorage from 'react-secure-storage';

export const getAuthorizationHeader = () => {
  const token = secureLocalStorage.getItem('user');
  if (!token) {
    return null;
  }
  if (jwtDecode(token).exp * 1000 < Date.now()) {
    secureLocalStorage.clear();
    window.location.pathname = '/login';
    return false;
  }
  return { Authorization: `Bearer ${token}` };
};
